// extracted by mini-css-extract-plugin
export var form = "_eb-0";